import { useClearCache } from '@hooks/useCaching';
import {
  Memory as MemoryAllIcon,
  Tune as RedisAdvSearchIcon,
  Storage as RedisAllIcon,
  Sort as RedisListContactIcon,
} from '@mui/icons-material';
import { Box, Grid, IconButton, SxProps, Theme, Tooltip, Typography } from '@mui/material';

const cacheButtonSx = { border: '1px solid lightgrey', borderRadius: '20px' };

type ClearCachesSectionProps = {
  sx?: SxProps<Theme>;
};

export default function ClearCachesSection({ sx }: ClearCachesSectionProps) {
  const {
    mutateAsync: clearCacheRedisAdvancedSearch,
    isPending: isClearingCacheRedisAdvancedSearch,
  } = useClearCache('redis.AdvancedSearch');

  const { mutateAsync: clearCacheRedisListContact, isPending: isClearingCacheRedisListContact } =
    useClearCache('redis.ListContact');

  const { mutateAsync: clearCacheRedisAll, isPending: isClearingCacheRedisAll } =
    useClearCache('redis.All');

  // const { mutateAsync: clearCacheMemoryAll, isLoading: isClearingCacheMemoryAll } =
  //   useClearCache('redis.All');

  return (
    <Box sx={sx}>
      <Typography variant="h6">Clear caches</Typography>
      <Grid
        container
        direction="row"
        sx={{
          gap: 1,
          marginTop: 2
        }}>
        <Grid sx={cacheButtonSx}>
          <Tooltip title="redis.AdvancedSearch">
            <IconButton
              size="medium"
              color="warning"
              onClick={() => clearCacheRedisAdvancedSearch()}
              disabled={isClearingCacheRedisAdvancedSearch}
              aria-label="Clear redis.AdvancedSearch cache"
            >
              <RedisAdvSearchIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid sx={cacheButtonSx}>
          <Tooltip title="redis.ListContact">
            <IconButton
              size="medium"
              color="warning"
              onClick={() => clearCacheRedisListContact()}
              disabled={isClearingCacheRedisListContact}
              aria-label="Clear redis.ListContact cache"
            >
              <RedisListContactIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid sx={cacheButtonSx}>
          <Tooltip title="redis.All(CURRENTLY BREAKS THINGS!)">
            <IconButton
              size="medium"
              color="warning"
              onClick={() => clearCacheRedisAll()}
              disabled={isClearingCacheRedisAll}
              aria-label="Clear redis.All cache"
            >
              <RedisAllIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid sx={cacheButtonSx}>
          <Tooltip title="memory.all (not implemented)">
            {/* The span allows the tooltip to show despite being disabled */}
            <span>
              <IconButton
                size="medium"
                color="warning"
                onClick={() => {}}
                disabled={true}
                aria-label="Clear memory.all cache (not implemented)"
              >
                <MemoryAllIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Grid>
      </Grid>
    </Box>
  );
}